<template>
  <div
    v-if="showScroll"
    class="fixed-bottom mobile-back-to-top"
    :style="`left: auto; right: 5px; bottom: ${props.bottom}px`"
  >
    <b-img :src="scrollImage" @click="scroll" />
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount } from 'vue'

type Props = {
  bottom?: number
}

const props = withDefaults(defineProps<Props>(), {
  bottom: 8
})

const showScroll = ref<boolean>(false)

const scroll = (): void => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}

const scrollEvent = (): void => {
  showScroll.value = window.pageYOffset > 0
}

window.addEventListener('scroll', scrollEvent)

onBeforeUnmount(() => {
  window.removeEventListener('scroll', scrollEvent)
})

const scrollImage = new URL('/src/assets/svg/back_top_icon.svg', import.meta.url).href
</script>
